import { Component } from '@angular/core';
import { membersuiteChapterDuesProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Chapter Dues Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitechapterduesproduct-form',
    templateUrl: './membersuitechapterduesproduct.form.component.html'
})
export class membersuiteChapterDuesProductFormComponent extends BaseFormComponent {
    public record!: membersuiteChapterDuesProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

